import React from 'react';

export const Stack = () => {
    const stack = [
      "HTML",
      "JavaScript",
      "Keras",
      "MetaTrader 4",
      "MQL4(MetaQuotes Language 4)",
      "NumPy",
      "Pandoc",
      "PIL",
      "Python",
      "R",
      "TensorFlow",
      "jQuery",
      "scikit-learn",
      "requests",
      "codecs",
      "Google Colab",
      "SQL",
      "PostgreSQL",
      "Google Cloud Platform",
      "MySQL",
      "Power BI",
      "Tableau",
      "Seaborn",
      "Matplotlib"
    ];

    return (
      <section className="random-stack-section" id="my-stack">
        <h1 id="stack">Technologies I've Worked With</h1>
        <div className="stack-container">
          {stack.map((technology) => (
            <span
              key={technology}
              className={'stack-item visible'}>
              {technology}
            </span>
          ))}
        </div>
      </section>
    );
  };